import React from 'react';
interface CtaSectionProps {
  onOpenWaitlist: () => void;
}
export const CtaSection: React.FC<CtaSectionProps> = ({
  onOpenWaitlist
}) => {
  return <section className="py-16 md:py-24 bg-gradient-to-r from-rejoy-coral to-rejoy-coral-hover" data-id="element-67">
      <div className="section-container" data-id="element-68">
        <div className="text-center space-y-6 max-w-3xl mx-auto" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-literata font-medium text-white mb-4" data-id="element-70">
            Be the first to experience Re:Joy.
          </h2>
          <p className="text-xl text-white/90 leading-relaxed" data-id="element-71">
            Join our waitlist to get early access to holistic trauma therapy —
            guided by data, supported by community, delivered by experts.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 pt-6" data-id="element-72">
            <button onClick={onOpenWaitlist} className="bg-white text-rejoy-coral font-medium py-3 px-6 rounded-xl min-w-[200px] min-h-[56px] transition-all duration-300 hover:bg-white/90 active:opacity-90" data-id="element-73">
              Join Waitlist →
            </button>
            <div className="bg-white/10 text-white font-medium py-3 px-6 rounded-xl min-w-[200px] min-h-[56px] flex items-center justify-center text-center select-none border-[1.5px] border-white/30" data-id="element-74">
              We're building something meaningful together.
            </div>
          </div>
          <div className="mt-8 relative h-8" data-id="element-75">
            <svg className="w-full h-full" viewBox="0 0 400 30" xmlns="http://www.w3.org/2000/svg" data-id="element-76">
              <path d="M0,15 Q25,5 50,15 T100,15 T150,15 T200,15 T250,15 T300,15 T350,15 T400,15" fill="none" stroke="white" strokeWidth="1.5" strokeOpacity="0.3" data-id="element-77" />
              <path d="M0,15 Q25,25 50,15 T100,15 T150,15 T200,15 T250,15 T300,15 T350,15 T400,15" fill="none" stroke="white" strokeWidth="1.5" strokeOpacity="0.5" data-id="element-78" />
            </svg>
          </div>
        </div>
      </div>
    </section>;
};